import { useState } from "react";
import { BrowserRouter } from "react-router-dom";
import { AppRoutes } from "./router";
import { I18nextProvider } from "react-i18next";
import i18n from "./i18n";
import ScrollToTopButton from "./components/feature/ScrollToTopButton";
import SplashScreen from "./components/feature/SplashScreen";
import CookieBanner from "./components/feature/CookieBanner";

const SPLASH_KEY = "spdb_splash_v1";

function App() {
  const [showSplash, setShowSplash] = useState<boolean>(
    () => !sessionStorage.getItem(SPLASH_KEY)
  );

  const handleSplashComplete = () => {
    sessionStorage.setItem(SPLASH_KEY, "1");
    setShowSplash(false);
  };

  return (
    <I18nextProvider i18n={i18n}>
      <BrowserRouter basename={__BASE_PATH__}>
        {showSplash && (
          <SplashScreen onComplete={handleSplashComplete} />
        )}
        <AppRoutes />
        <ScrollToTopButton />
        <CookieBanner />
      </BrowserRouter>
    </I18nextProvider>
  );
}

export default App;
